import { render, staticRenderFns } from "./InterpretationOptions.vue?vue&type=template&id=3222326d&"
import script from "./InterpretationOptions.vue?vue&type=script&lang=js&"
export * from "./InterpretationOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports